//import {filter as _filter} from 'lodash';

import { SET_TEAMFILTER } from "../actions";
import { SET_YEARFILTER } from "../actions";
import { SET_GYMNASTFILTER } from "../actions";
import { SET_GYMNASTS } from "../actions";
import { SET_MEETS } from "../actions";
import { SET_SCHEMA } from "../actions";
import { SET_SHOWLOADER } from "../actions";
import { SET_DASHBOARD_DATA } from "../actions";
import { SET_NUMROWS } from "../actions";
import { SET_COLS } from "../actions";
import { SET_ISVALIDTEAMYEAR } from "../actions";

const initialState = {
  data: [],
  teamFilter: 0,
  yearFilter: 2025,
  gymnastFilter: 0,
  gymnasts: [],
  meets: [],
  teams: [],
  years: [],
  schema: {},
  tempGID: 0,
  isValidTeamYear: false,
  showLoader: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_TEAMFILTER:
      return { ...state, teamFilter: action.payload };
    case SET_YEARFILTER:
      return { ...state, yearFilter: Number(action.payload) };
    case SET_GYMNASTFILTER:
      return { ...state, gymnastFilter: action.payload };
    case SET_GYMNASTS:
      return { ...state, ...action.payload };
    case SET_MEETS:
      return { ...state, meets: action.payload };
    case SET_SCHEMA:
      return { ...state, schema: action.payload };
    case SET_SHOWLOADER:
      return { ...state, showLoader: action.payload };
    case SET_DASHBOARD_DATA:
      return { ...state, ...action.payload };
    case SET_NUMROWS:
      return { ...state, numRows: action.payload };
    case SET_COLS:
      return { ...state, cols: action.payload };
    case SET_ISVALIDTEAMYEAR:
      return { ...state, isValidTeamYear: action.payload };
    default:
      return state;
  }
}
